import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { getQuizSectionalQuestions } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { Spacings } from '@styles/index';
import useOngoingSection from '@cont/Quiz/Taking/Common/useOngoingSection';
import Question from './Question';
import QuestionsInfo from './QuestionsInfo';

const Wrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const SectionQuestionList = styled.div`
  display: grid;
  margin: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B} 0;
  gap: ${Spacings.SPACING_4B};
  grid-template-columns: repeat(auto-fill, ${Spacings.SPACING_8B});
`;

const Questions = ({ title, sectionUID }) => {
  const { query } = useRouter();
  const { quizUID } = query;

  const { allIds, byId } = useSelectorWithShallowEqual(
    getQuizSectionalQuestions(quizUID, sectionUID)
  );

  const { hasOngoingSectional, isLocked, isCompleted } =
    useOngoingSection(sectionUID);

  if (isLocked) {
    return null;
  }

  const renderQuestionNumber = () => (
    <SectionQuestionList>
      {allIds.map((id) => (
        <Question
          key={id}
          sectionUID={sectionUID}
          questionUID={id}
          isLocked={isLocked}
          rank={byId[id].question_rank}
        />
      ))}
    </SectionQuestionList>
  );

  return (
    <Wrapper>
      <QuestionsInfo
        title={title}
        sectionUID={sectionUID}
        isLocked={isLocked}
        isCompleted={isCompleted}
        hasOngoingSectional={hasOngoingSectional}
      />
      {renderQuestionNumber()}
    </Wrapper>
  );
};

export default Questions;

Questions.propTypes = {
  title: PropTypes.string.isRequired,
  sectionUID: PropTypes.string.isRequired
};
